<template>
    <div class="container">
        <div class="left" @click="showMenu">
            <userMenu :headImg="require('../../public/images/user.jpg')" :currentType="3" :showFlag="menuFlag"></userMenu>
        </div>
        <div class="right">
            <h5>意见反馈</h5>
            <section class="userform">
                <div class="field">
                    <span>反馈标题：</span>
                    <div>
                        <input type="text" placeholder="" v-model="title">
                    </div>
                </div>
                <div class="field">
                    <span>反馈内容：</span>
                    <div>
                        <textarea v-model="desc"></textarea>
                    </div>
                </div>
                <div class="field">
                    <span>姓名：</span>
                    <div>
                        <input type="text" placeholder="" v-model="name">
                    </div>
                </div>
                <div class="field">
                    <span>联系方式：</span>
                    <div >
                        <input type="text" placeholder="" v-model="tel">
                    </div>
                </div>
                <div class="btn btn-primary" style="width: 100%;margin-top: 20px;" @click="submit">提交反馈</div>
            </section>
        </div>
    </div>
</template>

<script>
    import userMenu from '../components/user.vue'
    export default {
        inject: ['ajax'],
        data() {
            return {
                phoneEditFlag:false,
                menuFlag:false,
                name:'',
                title:'',
                desc:'',
                tel:''
            };
        },
        computed: {

        },
        created() {

        },
        mounted() {
            this.ajax('/api/user/info', 'get', '', res => {
                this.userInfo = res.data.data
                this.beforePhone = this.userInfo.tel
            })
        },
        watch: {

        },
        methods: {
            showMenu(){
                this.menuFlag = !this.menuFlag
            },
            // 图片验证码
            reloadCaptcha(e) {
                e.target.src = e.target.src
            },
            // 修改手机
            showPhoneEdit(){
                this.phoneEditFlag = true
            },
            // 发送验证码
            sendCode() {
               if (!this.captcha) {
                    this.$toast('图形验证码为必填')
                    return
                }
                if (!this.sendFlag) {
                    this.sendFlag = true
                    this.ajax(`/api/reg/sendmsgcaptcha?tel=${this.beforePhone}&pic_captcha=${this.captcha}`, 'get', '', res => {
                        this.$toast('验证码已发送至原手机号，请注意查收')
                        let total = 60
                        let timer = setInterval(() => {
                            total--
                            if (total <= 0) {
                                clearInterval(timer)
                                this.codeText = '重新获取'
                                this.sendFlag = false
                            } else {
                                this.codeText = `${total.toString()[1]?total:'0'+total}s`
                            }
                        }, 1000)
                    },()=>{
                        this.sendFlag = false
                    })
                }

            },
            // 头像上传
            upload(e) {
                let that = this
                let img = e.target.files[0];
                let param = new FormData()
                param.append('file', img)
                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
                this.axios.post('/api/user/image', param, config)
                    .then(res => {
                        console.log(res)
                        if (res.data.errcode == 0) {
                            that.userInfo.avatar = res.data.data.url
                        } else {
                            that.$toast(res.data.errmsg)
                        }
                    })
            },
            // 用户信息修改
            submit() {
                let parmas = {
                    tel:this.tel,
                    name:this.name,
                    title:this.title,
                    desc:this.desc
                }
                this.ajax('/api/user/feedBack', 'post', this.$qs.stringify(parmas), res => {
                    this.$toast('提交成功', 1500)
                    setTimeout(() => {
                        this.$router.go(0)
                    }, 1500)
                })
            }

        },
        components: {
            userMenu
        },
    }
</script>

<style scoped>
    .container {
        display: flex;
        justify-content: space-between;
    }

    .left {
        width: 200px;
    }

    .userform {
        width: 26.8em;
        margin: 0 auto;
    }

    .field {
        display: flex;
        align-items: flex-start;
        min-height: 80px;
        padding: 15px 0;
    }

    .field>span {
        color: #333;
        font-weight: bold;
        font-size: 1em;
        width: 135px;
        line-height: 45px;
        overflow: scroll;
        overflow: hidden;
    }

    .field>div {
        width: calc(100% - 100px);
        overflow: hidden;
    }

    .field input[type="text"],textarea {
        font-size: 1em;
        border: 1px solid #cfcfcf;
        width: 100%;
        line-height: 45px;
        padding: 5px 10px;
        border-radius: 7px;
        height: 45px;
        outline: none;
    }
    textarea{
        height: 100px;
        line-height: 1.5;
    }
    .sex {
        display: inherit;
        font-size: 0.9em;
        color: #aaaaaa;
    }

    .sex input {
        margin-right: 6px;
    }

    .images {
        width: 5.5em;
        height: 5.5em;
        border-radius: 50%;
        overflow: hidden;
    }

    .images>img {
        width: 100%;
        height: 100%;
        object-fit: cover;

    }

    .sex label {
        margin-right: 20px;
    }

    .flex {
        display: inherit;
        align-items: center;
    }

    .flex .btn {
        line-height: 45px;
        margin-left: 15px;
        position: relative;
    }

    input[type="file"] {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        opacity: 0;
    }
    .vertCode>input {
        width: 220px!important;
    }
    .vert {
        width: 156px!important;
        height: 45px;
        border: 1px solid #dfdfdf;
        cursor: pointer;
    }

    .vert img {
        width: 100%;
        height: 100%;
    }

    .code {
        font-size: 1em;
        line-height: 45px;
        text-align: center;
        color: #a3a3a3;
        cursor: pointer;
    }
    @media only screen and (max-width: 750px){
        .right>h5{font-size: 1em;}
        .userform{width: 100%;}
        .field>span{font-size: 0.14rem;}
        .flex .btn{height: 0.35rem!important;line-height: 0.35rem;max-width: 1rem;}
        .field input[type="text"]{
            font-size: 0.14rem!important;
            height: 0.35rem;
            line-height: 0.35rem;
        }
        .field{min-height: 0.6rem;}
        .images{width: 0.7rem;height: 0.7rem;}
        .vert{height: 0.35rem;line-height: 0.35rem;font-size: 0.14rem;overflow: hidden;}
        .vertCode>input{
            width: 1.3rem!important;
        }
    }
</style>